import { useSelector } from 'react-redux';

const UserDefinedLabels = () => {
  const { adminConfigData } = useSelector((state) => state.user);
  const { employeeInfo } = useSelector((state) => state.memberSummary);

  const CertificateNumber =
    adminConfigData?.Response?.AttributeNameConfiguration.filter(
      (item) => item.attributeKey === 'certificateNumber',
    );
  const AlternateID1 =
    adminConfigData?.Response?.AttributeNameConfiguration.filter(
      (item) => item.attributeKey === 'alternateID1',
    );
  const AlternateID2 =
    adminConfigData?.Response?.AttributeNameConfiguration.filter(
      (item) => item.attributeKey === 'alternateID2',
    );

  const GetDefaultMemberIDKey = () => {
    const defaultMemberID =
      adminConfigData &&
      adminConfigData?.Response?.AttributeNameConfiguration.filter(
        (item) => item.memberID,
      );
    const str = defaultMemberID && defaultMemberID[0].attributeKey;
    const key = str && str.charAt(0).toUpperCase() + str.slice(1);
    return key;
  };

  return {
    CertificateNumberLabel: CertificateNumber
      ? CertificateNumber[0]?.attributeValue
      : '',
    AlternateID1Label: AlternateID1 ? AlternateID1[0]?.attributeValue : '',
    AlternateID2Label: AlternateID2 ? AlternateID2[0]?.attributeValue : '',
    GetDefaultMemberIDKey: GetDefaultMemberIDKey(),
  };
};

export default UserDefinedLabels;
